import { FC } from "react";
import { Link } from "react-router-dom";
import { SidebarMenuButton, SidebarMenuItem, SidebarSeparator } from "@capacit-com/lara-law-shared-ui";
import {  } from "@capacit-com/lara-law-shared-ui";
import type { NavigationItemType } from "@/constants/routes/NavItems";

interface Props {
  items: NavigationItemType[];
  currentPath: string;
  open: boolean;
  indent?: boolean;
  sliceNumber?: number;
  customIsActive?: boolean | undefined;
  noSeperator?: boolean;
}

const SidebarMenuList: FC<Props> = ({
  items,
  currentPath,
  open,
  indent = false,
  sliceNumber = 2,
  customIsActive,
  noSeperator = false,
}) => (
  <div className={`flex flex-col ${indent && open ? "gap-1 ml-4" : "gap-1"}`}>
    <>
      {items.map((item, idx) => (
        <SidebarMenuItem key={item.name} className="first:pt-1">
          <SidebarMenuButton
            asChild={!!item.path}
            isActive={
              customIsActive !== undefined
                ? customIsActive
                : currentPath.startsWith(
                    item.path?.split("/").slice(0, sliceNumber).join("/") ?? ""
                  )
            }
            tooltip={item.name}
            className="cursor-pointer"
          >
            {item.path ? (
              <Link to={item.path} data-testid={`nav-item-${idx}`}>
                {item.icon && <item.icon className="size-4" />}
                <span>{item.name}</span>
              </Link>
            ) : (
              <div
                data-testid={`nav-item-${idx}`}
                onClick={() => item.onClick?.()}
                className="w-full h-8 cursor-pointer flex items-center gap-2"
              >
                {item.icon && <item.icon className="size-4" />}
                {open && <span>{item.name}</span>}
              </div>
            )}
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
      {!open && !noSeperator && <SidebarSeparator className={`mx-0 max-w-8`} />}
    </>
  </div>
);

export default SidebarMenuList;
